import styled from 'vue-styled-components';

import { FONTS } from '../../constants';
import { device } from '../../utils/media';

export const Container = styled('div', { isTopSpace: Boolean })`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 30px;
  font-family: ${FONTS.KNOCKOUT_50_FONT};
  position: relative;
  z-index: 2;
  font-size: 18px;
  margin-top: ${({ isTopSpace }) => (isTopSpace ? '20px' : 0)};

  @media ${device.desktop} {
    margin-top: ${({ isTopSpace }) => (isTopSpace ? '40px' : 0)};
    flex-direction: row;
  }
`;
